import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
const label = z.string().trim().min(1).max(300);
export const relationshipsOrganizationDetailCopySchema = z.strictObject({
    back: label, loading: label, error: label, denied: label, retry: label,
    type: label, status: label, address: label, website: label, notes: label,
    phone: label, email: label, privateHidden: label, contacts: label,
    search: label, empty: label, contactsError: label, previous: label, next: label,
});
export const relationshipsOrganizationDetailCopySetting = definePlatformSetting({
    definition: {
        key: 'relationships.copy.organization-detail', moduleId: 'relationships',
        title: 'Organization detail copy', helpText: 'Organization summary and linked-contact navigation labels.',
        configurationDomain: 'copy', valueType: 'object', schemaVersion: 1,
        codedFallback: {
            back: 'All Organizations', loading: 'Loading organization…', error: 'Organization could not be loaded.',
            denied: 'You do not have access to this organization.', retry: 'Retry',
            type: 'Type', status: 'Status', address: 'Address', website: 'Website', notes: 'Profile notes',
            phone: 'Phone', email: 'Email', privateHidden: 'Private phone and email details are hidden.',
            contacts: 'Linked contacts', search: 'Search linked contacts', empty: 'No matching linked contacts.',
            contactsError: 'Linked contacts could not be loaded.', previous: 'Previous contacts', next: 'Next contacts',
        },
        permittedScopes: ['platform', 'plan', 'tenant'], mergeStrategy: 'deep-merge',
        clientSafe: true, serverOnly: false, sensitive: false, tenantEditable: true,
        userOverridable: false, offlineEligible: true, safetyClass: 'ordinary',
    },
    valueSchema: relationshipsOrganizationDetailCopySchema,
});
//# sourceMappingURL=relationships-organization-detail-copy.js.map